import { UserAnalyticsResultModel } from './../models/UserModel';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import UserModel from "../models/UserModel";

const initialState: UserModel = {
    id: -1,
    email: "",
    userGroup: "",
    displayName: "",
    workingEmail: "",
    isLocked: true,
    password: "",
    lastLogin: "",
    signature: "",
    defaultSignatureId: "",
    defaultSignatureEvoId: "",
    analytics: {
        lastActiveDate: "",
        inputToday: 0,
        searchToday: 0,
        inputMonth: 0,
        searchMonth: 0,
        inputYear: 0,
        searchYear: 0,
    } as UserAnalyticsResultModel,
    emailDisplayName: ""
}

export const UserProfileSlice = createSlice({
    name: "UserProfile",
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<UserModel>) => {
            state.email = action.payload.email;
            state.userGroup = action.payload.userGroup;
            state.analytics = action.payload.analytics;
            state.lastLogin = action.payload.lastLogin;
            state.signature = action.payload.signature;
            state.defaultSignatureId = action.payload.defaultSignatureId;
            state.defaultSignatureEvoId = action.payload.defaultSignatureEvoId;
            state.id = action.payload.id;
        },
        setSignature: (state, action: PayloadAction<string>) => {
            state.signature = action.payload;
        },
        setDefaultSignatureId: (state, action: PayloadAction<string>) => {
            state.defaultSignatureId = action.payload;
        },
        setDefaultEvoSignatureId: (state, action: PayloadAction<string>) => {
            state.defaultSignatureEvoId = action.payload;
        },
    }
});

export const userProfileSelector = createSelector(
    (state: RootState) => state.userProfile,
    (data) => data
);

export const {
    setUser,
    setSignature,
    setDefaultSignatureId,
    setDefaultEvoSignatureId
} = UserProfileSlice.actions;

export default UserProfileSlice.reducer;